import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ButtonComponent, DialogComponent, IconComponent } from '@components';
import { CustomerService } from '@customer';
import { RemoveApplianceDialogData } from '../../models/remove-appliance-dialog-data.interface';

@Component({
  selector: 'app-remove-appliance-dialog',
  standalone: true,
  imports: [
    ButtonComponent,
    DialogComponent,
    IconComponent,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './remove-appliance-dialog.component.html',
  styleUrl: './remove-appliance-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class RemoveApplianceDialogComponent {
  private readonly customerService = inject(CustomerService);
  private readonly dialog = inject(MatDialog);
  private readonly dialogRef = inject(
    MatDialogRef<RemoveApplianceDialogComponent>,
    { optional: true },
  );
  protected readonly data = inject<RemoveApplianceDialogData>(MAT_DIALOG_DATA, {
    optional: true,
  });

  private readonly router = inject(Router);

  open(
    data: RemoveApplianceDialogData,
    configOverrides?: Partial<MatDialogConfig>,
  ): MatDialogRef<RemoveApplianceDialogComponent> {
    return this.dialog.open(RemoveApplianceDialogComponent, {
      ariaLabel: `Remove appliance for ${data.clientName}`,
      ariaDescribedBy: 'remove-appliance-dialog-description',
      panelClass: 'remove-appliance-dialog',
      backdropClass: 'remove-appliance-dialog__backdrop',
      ...configOverrides,
      data,
    });
  }

  protected onConfirm(): void {
    this.customerService.setCustomerSelectedToPurchasePlan(false);
    this.customerService.setCustomerSelectedToRegisterOnly(true);
    this.router.navigate(['contact-details']);
    this.dialogRef?.close(true);
  }

  protected onCancel(): void {
    this.dialogRef?.close(false);
  }
}
